<script setup lang="ts">
import type {LocationResponse} from "../../../responses/LocationResponse.ts";
import type {ProductResponse} from "../../../responses/ProductResponse.ts";
import Carousel from "../../ui/carousel/Carousel.vue";
import CarouselContent from "../../ui/carousel/CarouselContent.vue";
import CarouselItem from "../../ui/carousel/CarouselItem.vue";
import type {CarouselProps} from "../../ui/carousel/interface.ts";
import PreventInteraction from "../PreventInteraction.vue";
import CarouselNext from "./CarouselNext.vue";
import CarouselPrevious from "./CarouselPrevious.vue";
import Product from "./Product.vue";

interface Props {
    products: ProductResponse[],
    location?: string,
    showImage?: boolean,
    inlineNavigation?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
    showImage: true,
    inlineNavigation: false,
    location: null,
});

const carouselOpts: CarouselProps = {
    opts: {
        align: 'start',
        loop: false,
        dragFree: false,
    },
    plugins: []
};
</script>

<template>
    <Carousel
        :opts="carouselOpts.opts"
        :plugins="carouselOpts.plugins"
        class="w-full max-w-full min-w-0 overflow-hidden px-0"
    >
        <div class="hidden lg:flex gap-2 mb-4 justify-self-end mr-4" v-if="products.length > 3 && !inlineNavigation">
            <CarouselPrevious/>
            <CarouselNext />
        </div>
        <CarouselContent class="grid w-full min-w-0 grid-flow-col gap-x-4 gap-y-0.5
               auto-cols-[100%]
               sm:auto-cols-[calc((100%_-_1rem)/2)]
               lg:auto-cols-[calc((100%_-_2rem)/3)]">
            <CarouselItem
                v-for="(product, index) in products"
                :key="index"
                class="min-w-0 grid grid-rows-subgrid row-span-4 px-0">
                <prevent-interaction>
                    <Product class="h-full"
                        :product="product"
                        :show-image="showImage"
                        :location="location"/>
                </prevent-interaction>
            </CarouselItem>
        </CarouselContent>

        <CarouselPrevious v-if="inlineNavigation" class="md:hidden absolute -left-0 lg:-left-8 top-1/2 -translate-y-1/2 bg-primary-600 text-white" />
        <CarouselNext v-if="inlineNavigation" class="md:hidden absolute -right-0 lg:-right-8 top-1/2 -translate-y-1/2 bg-primary-600 text-white" />
        <CarouselPrevious v-if="inlineNavigation && products.length > 3" class="hidden lg:block absolute -left-3 lg:-left-8 top-1/2 -translate-y-1/2 bg-primary-600 text-white" />
        <CarouselNext v-if="inlineNavigation && products.length > 3" class="hidden lg:block absolute -right-3 lg:-right-8 top-1/2 -translate-y-1/2 bg-primary-600 text-white" />
    </Carousel>
</template>
